// ─────────────────────────────────────────────
// Report Configs — add/edit reports here only
// ─────────────────────────────────────────────

export type ColumnConfig = {
  key: string;
  label?: string;   // display name; falls back to key if omitted
  hidden?: boolean; // exclude from table & export
  boolean?: boolean; // render true/false as Yes/No
};

export type ModalType = "userEdit" | "userNew" | "generic";

export type ReportAction = {
  label: string;
  handler: (rows: any[]) => void;
};

export type ReportConfig = {
  apiKey: string;                        // used to pick the right fetch fn
  title: string;
  columns: ColumnConfig[];
  canEdit?: boolean;
  canDelete?: boolean;
  canCreate?: boolean;
  editModal?: ModalType;                 // which modal opens on edit
  newModal?: ModalType;                  // which modal opens on new
  genericModalFields?: GenericField[];   // used when modal = "generic"
  bulkActions?: ReportAction[];
};

export type GenericField = {
  key: string;
  label: string;
  type?: "text" | "textarea" | "select";
  options?: string[]; // for select
  required?: boolean;
};

// ─────────────────────────────────────────────
export const REPORT_CONFIGS: Record<string, ReportConfig> = {
  users: {
    apiKey: "users",
    title: "User Master",
    canEdit: true,
    canDelete: true,
    canCreate: true,
    editModal: "userEdit",
    newModal: "userNew",
    columns: [
      { key: "id", hidden: true },
      { key: "employeeid", label: "Employee ID" },
      { key: "firstname", label: "First Name" },
      { key: "lastname", label: "Last Name" },
      { key: "leadname", label: "Lead Name" },
      { key: "emailaddress", label: "Email" },
      { key: "roles", label: "Roles" },
      { key: "groups", label: "Groups" },
      { key: "documenttypes", label: "Doc. Types" },
      { key: "iswnsemployee", label: "WNS Employee", boolean: true },
      { key: "contactnumber", label: "Contact No." },
      { key: "active", label: "Active", boolean: true },
      { key: "islocked", label: "Locked", boolean: true },
      { key: "isloggedin", label: "Online", boolean: true },
      { key: "isresetrequired", label: "Reset Req.", boolean: true },
      { key: "invalidattemptcount", label: "Bad Attempts" },
    ],
  },

  group: {
    apiKey: "group",
    title: "Group Master",
    canEdit: true,
    canDelete: true,
    canCreate: true,
    editModal: "generic",
    newModal: "generic",
    genericModalFields: [
      { key: "groupname", label: "Group Name", type: "text", required: true },
      { key: "groupdescription", label: "Description", type: "textarea" },
    ],
    columns: [
      { key: "id", hidden: true },
      { key: "groupname", label: "Group Name" },
      { key: "groupdescription", label: "Description" },
    ],
  },

  reasoncodes: {
    apiKey: "reasoncodes",
    title: "Reason Code",
    canEdit: true,
    canDelete: true,
    canCreate: true,
    editModal: "generic",
    newModal: "generic",
    genericModalFields: [
      { key: "code", label: "Reason Code", type: "text", required: true },
      { key: "description", label: "Description", type: "textarea" },
      { key: "type", label: "Type", type: "select", options: ["Inbound", "Outbound", "General"] },
    ],
    columns: [
      { key: "id", hidden: true },
      { key: "reasoncode", label: "Reason Code" },
      { key: "description", label: "Description" },
      { key: "reasontypename", label: "Reason Type" },
      { key: "rolename", label: "Role" },
      { key: "errorcategory", label: "Error Category" },
      { key: "errorsubcategory", label: "Error Sub Catagory" },
      { key: "doctypes", label: "Document Type" },
      { key: "isdefault", label: "Document Type" },
    ],
  },
};
